<template>
  <div class="app-container">
    <!-- 主容器 -->
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <!-- 搜索表单 -->
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="100px">
          <!-- 搜索条件行 -->
          <el-row :gutter="24" type="flex" justify="right">
            <!-- 客户名称搜索 -->
            <el-col :span="6">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称"  @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <!-- 使用单位搜索 -->
            <el-col :span="6">
              <el-form-item label="使用单位" prop="usingUnit">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <!-- 检测时间搜索 -->
            <el-col :span="6">
              <el-form-item label="检测时间" prop="testDateRange">
                <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="inputStatus">
                <el-select v-model="queryParams.inputStatus" placeholder="请选择状态" clearable @change="handleQuery" style="width:100%" >
                  <el-option label="未录入" :value="0" />
                  <el-option label="已录入" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="6">
              <el-form-item label="小区名称" prop="houseName">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="到检年月" prop="inspectionMonthList">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 功能按钮区域 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleQuery" @handleSave="handleBatchSave" @exportToExcel="exportToExcel" />
          </div>

          <!-- 数据表格 -->
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                    @selection-change="handleSelectionChange" height="500">
            <!-- 多选框列 -->
            <el-table-column type="selection" width="55" align="left"></el-table-column>
            <!-- 序号列 -->
            <el-table-column label="序号" align="left" type="index" width="50" show-overflow-tooltip></el-table-column>
            <!-- 识别码列 -->
            <el-table-column label="识别码" align="left" prop="oidNo" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 委托编号列 -->
            <el-table-column label="委托编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
            <!-- 层数/高度/长度列 -->
            <el-table-column label="层数/高度/长度" align="left" prop="ELEFLOORNUMBER" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 使用单位列 -->
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- 小区名称列 -->
            <el-table-column label="小区名称" align="left" prop="houseName" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- 到检年月列 -->
            <el-table-column label="到检年月" align="left" prop="inspectionMonth" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- 客户名称列 -->
            <el-table-column label="客户名称" align="left" prop="compName" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- 配合费列 -->
            <el-table-column label="配合费" align="left" prop="cooperationFee" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.cooperationFee && scope.row.cooperationFee > 0 ? scope.row.cooperationFee : '' }}
              </template>
            </el-table-column>
            <!-- 标准价列 -->
            <el-table-column label="标准价" align="left" prop="testCharge" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 折扣列 -->
            <el-table-column label="折扣" align="left" prop="custDiscount" min-width="80" show-overflow-tooltip></el-table-column>
            <!-- 折后价列 -->
            <el-table-column label="折后价" align="left" prop="finalPrice" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 检测时间列 -->
            <el-table-column label="检测时间" align="left" prop="testEmployeeDate" min-width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
            <!-- 检测员列 -->
            <el-table-column label="检测员" align="left" prop="employeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- 操作列 -->
            <el-table-column label="操作" align="left" prop="operation" min-width="100" show-overflow-tooltip fixed="right">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)" @handleEdit="handleEdit(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.currPage"
            :page-sizes="[500, 1000]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 新增/修改配合费用弹窗组件 -->
    <CoordinationFeeDialog ref="coordinationFeeDialog" @refresh="getList" />
  </div>
</template>

<script>
// 导入API接口
import { queryCoordinationFeeList, exportCoordinationFee } from '@/api/contract/contract'
// 导入配合费用弹窗组件
import CoordinationFeeDialog from './CoordinationFeeDialog.vue'
// 导入权限按钮组件
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'
import PermissionMethodRow from '@/components/button/PermissionMethodRow.vue'

export default {
  name: 'InspectionCoordinationFee',
  props: {
    // 页面URL，用于权限按钮组件
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    CoordinationFeeDialog,
    PermissionMethodToolbar,
    PermissionMethodRow
  },
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 500,
        compNames: '',
        usingUnit: '',
        houseName: '',
        inspectionMonthList: [],
        testDateRange: [],
        inputStatus: 0
      },
      // 选中的数据
      selectedRows: []
    };
  },
  created () {
    // 页面加载时查询列表
    this.getList()
  },
  methods: {
    getDisabledButtons (row) {
      // 未录入（无 feeId）或已付款，均不显示修改按钮
      if (!row.feeId || row.paid === 1 || row.paid === '1') {
        return ['handleEdit']
      }
      return []
    },
    /**
     * 搜索按钮点击事件
     */
    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.getList()
    },

    /**
     * 查询列表数据
     */
    getList () {
      this.loading = true

      // 构建查询参数，只传有值的字段
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize || 500
      }

      // 如果客户名称有值，则添加到参数中
      if (this.queryParams.compNames) {
        params.compNames = this.queryParams.compNames
      }

      // 如果使用单位有值，则添加到参数中
      if (this.queryParams.usingUnit) {
        params.usingUnit = this.queryParams.usingUnit
      }

      if (this.queryParams.houseName) {
        params.houseName = this.queryParams.houseName
      }

      if (this.queryParams.inspectionMonthList) {
        params.inspectionMonthList = this.queryParams.inspectionMonthList
      }

      // 如果检测时间有值，则添加到参数中
      if (this.queryParams.testDateRange) {
        params.testDateRange = this.queryParams.testDateRange
      }

      // 录入状态：0-未录入，1-已录入（0 也是有效值，不能用 truthy 判断）
      if (this.queryParams.inputStatus !== null && this.queryParams.inputStatus !== undefined && this.queryParams.inputStatus !== '') {
        params.inputStatus = this.queryParams.inputStatus
      }

      // 调用查询接口
      queryCoordinationFeeList(params).then(res => {
        if (res.retCode === 'ok') {
          this.tableData = res.additionalData.records || res.additionalData.list || []
          this.total = res.additionalData.total
          this.loading = false
        } else {
          this.$message.error(res.retMsg)
          this.loading = false
        }
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败')
        this.loading = false
      })
    },

    /**
     * 多选框选中数据变化事件
     * @param {Array} selection - 选中的数据数组
     */
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },

    /**
     * 批量保存按钮点击事件
     */
    handleBatchSave () {
      // 检查是否选择了数据
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }

      // 检查是否有已录入配合费的数据
      const hasCooperationFee = this.selectedRows.filter(row => row.cooperationFee && row.cooperationFee > 0)
      if (hasCooperationFee.length > 0) {
        const oidNos = hasCooperationFee.map(row => row.oidNo).join(', ')
        this.$message.warning(`以下记录已录入配合费，不能重复录入：${oidNos}`)
        return
      }

      // 打开批量保存弹窗
      this.$refs.coordinationFeeDialog.openDialog(this.selectedRows, 'batch')
    },

    /**
     * 修改按钮点击事件
     * @param {Object} row - 当前行数据
     */
    handleEdit (row) {
      if (!row.feeId) {
        this.$message.warning('未录入配合费，请使用批量保存')
        return
      }
      if (row.paid === 1 || row.paid === '1') {
        this.$message.warning('该记录配合费已付款，不能修改')
        return
      }
      // 打开修改弹窗
      this.$refs.coordinationFeeDialog.openDialog([row], 'edit')
    },

    /**
     * 导出按钮点击事件
     */
    exportToExcel () {
      this.$message.success('正在导出检测配合费用数据...')

      // 构建导出参数，只传有值的字段
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }

      // 如果客户名称有值，则添加到参数中
      if (this.queryParams.compNames) {
        params.compName = this.queryParams.compNames
      }

      // 如果使用单位有值，则添加到参数中
      if (this.queryParams.usingUnit) {
        params.usingUnit = this.queryParams.usingUnit
      }

      if (this.queryParams.houseName) {
        params.houseName = this.queryParams.houseName
      }

      if (this.queryParams.inspectionMonthList) {
        params.inspectionMonthList = this.queryParams.inspectionMonthList
      }

      // 如果检测时间有值，则添加到参数中
      if (this.queryParams.testDateRange) {
        params.testDateRange = this.queryParams.testDateRange
      }
      // 录入状态：0-未录入，1-已录入（0 也是有效值，不能用 truthy 判断）
      if (this.queryParams.inputStatus !== null && this.queryParams.inputStatus !== undefined && this.queryParams.inputStatus !== '') {
        params.inputStatus = this.queryParams.inputStatus
      }

      // 调用导出接口
      exportCoordinationFee(params).then(response => {
        // 创建Blob对象
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接
        const link = document.createElement('a');
        link.href = url;
        link.download = '检测配合费用管理.xlsx';

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    }
  }
}
</script>

<style scoped>
/* 容器样式 */
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
